/* eslint-disable eqeqeq */
/* eslint-disable consistent-return */
import { Message } from 'view-design'

export default {
  /**
   * 限制只能输入数字，且保留小数后两位
   * @param {string} value - 输入的值
   * @param {string} name - 匹配的对象属性 [mkPrice | slPrice]
   */
  limitInput(value) {
    if (value) {
      return (
        `${value}`
          .replace(/[^\d^.]+/g, '')
          .replace(/^0+(\d)/, '$1')
          .replace(/^\./, '0.')
          .match(/^\d*(\.?\d{0,2})/g)[0] || ''
      )
    }
  },

  /**
   * 限制输入大于等于0小于等于1两位小数
   * @param {string} value - 输入的值
   * @param {string} name - 匹配的对象属性 [mkPrice | slPrice]
   */
  limitDiscount(value) {
    if (value) {
      return (
        `${value}`
          .replace(/[^\d^.]+/g, '')
          .replace(/^0+(\d)/, '0')
          .replace(/^[1-9]/, '0')
          .replace(/^\./, '0.')
          .match(/^\d*(\.?\d{0,2})/g)[0] || ''
      )
    }
  },
  // 限制输入可保留两位小数的非负数，blur方法后校验使用
  blurLimitPositiveDecimal(value, decimalDigits) {
    if (value) {
      let msg = '请输入非负数，可保留两位小数'
      let regex = /^[0-9]\d*(\.\d{1,2})?$/g
      if (decimalDigits == 4) {
        msg = '请输入非负数，可保留四位小数'
        regex = /^[0-9]\d*(\.\d{1,4})?$/g
      }
      value = String(value)
      const res = value.match(regex)
      if (res && res.length > 0) {
        return res[0]
      }
      Message.warning(msg)
    }
  },
  // 限制输入可保留两位小数的非负数
  limitPositiveDecimal(value, decimalDigits) {
    if (value) {
      let msg = '请输入非负数，可保留两位小数'
      let regex = /^[0-9]\d*\.?\d{0,2}$/g
      if (decimalDigits == 4) {
        msg = '请输入非负数，可保留四位小数'
        regex = /^[0-9]\d*\.?\d{0,4}$/g
      }
      value = String(value)
      const res = value.match(regex)
      if (res && res.length > 0) {
        return res[0]
      }
      Message.warning(msg)
    }
  },
  // 限制输入非负整数
  limitPositiveInteger(value) {
    if (value) {
      value = String(value)
      const regex = /^\+?[0-9]\d*$/g
      const res = value.match(regex)
      if (res && res.length > 0) {
        return res[0]
      }
      Message.warning('请输入非负数')
    }
  },
  // 限制输入字符长度
  limitValueLength(value, _maxLength, oldVal) {
    console.log(oldVal, 'oldVal')
    if (String(value).length > _maxLength) {
      Message.warning('输入内容已超出限制长度')
      return ''
    }
  }
}
